import {EntityData, ListEntityData} from 'common/api/entities'
import {EntitySelector} from 'common/components/reloadable/EntitySelector'
import {useEffect, useState} from 'react'

interface OwnedEntitySelector {
    ownerId?: number
    value?: number | number[]
    onChange?: (value?: number | number[]) => void
    searchEntities: (search: string, page: number, size: number, advertiserId?: number) => Promise<ListEntityData>
    loadEntity: (id: number) => Promise<EntityData>
    style?: React.CSSProperties
    placeholder?: string
    disabled?: boolean
    errorText?: string
    multiple?: boolean
}

export const OwnedEntitySelector = ({ownerId, value, onChange, searchEntities, loadEntity, style, disabled, placeholder, errorText, multiple}: OwnedEntitySelector) => {

    const [valueEntity, setValueEntity] = useState(value)
    const [ownerIdVal, setOwnerIdVal] = useState<number|undefined>()

    // React calls useEffect() by the order in the code. It is very important that we set advertiserId before the
    // setting of campaignId
    useEffect(() => {
      if (ownerId !== ownerIdVal) {
        setValueEntity(undefined)
      }
        setOwnerIdVal(ownerId)
    }, [ownerId, ownerIdVal])

    useEffect(() => {
      if (value === undefined) {
        setValueEntity(undefined)
      } else {
        setValueEntity(value)
      }
    }, [value])

    return <EntitySelector
        value={valueEntity}
        onChange={onChange}
        loadEntity={loadEntity}
        searchEntities={(search, page, size) => searchEntities(search, page, size, ownerIdVal)}
        placeholder={placeholder}
        disabled={disabled}
        style={style}
        errorText={errorText}
        multiple={multiple}
    />
}